import React, { memo, useEffect } from "react";
import { TransactionMessage } from "../../../../app/data/transaction-monitor/models";
import { useDispatch, useSelector } from "react-redux";
import { TransactionMessageIssueState } from "../../../../slices/transaction-monitor/transaction-messages/TransactionMessagesState";
import { getTransactionMessageIssueDetails, transactionMessageIssueSelector } from "../../../../slices/transaction-monitor/transaction-messages/transactionMessageIssueSlice";
import Loading from "../../../../ui-components/loading/loading";

export interface TransactionMessageErrorDetailsProps {
    transactionMessage: TransactionMessage
}

const TransactionMessageErrorDetails: React.FC<TransactionMessageErrorDetailsProps> = memo((props) => {
    const dispatch = useDispatch();
    const transactionMessageIssueState: TransactionMessageIssueState = useSelector(transactionMessageIssueSelector);

    useEffect(()=>{
        if(!transactionMessageIssueState.loading){
            dispatch(getTransactionMessageIssueDetails(props.transactionMessage.id))
        }
         // eslint-disable-next-line
    }, [props?.transactionMessage?.id])
    
    return (
       <div className="error-details">
        <div className="error-text">{
            (transactionMessageIssueState.loading) ? <Loading isLoading={true}></Loading>
            : transactionMessageIssueState.errorDetails.errorText
        }</div>
       </div>
    );
});

export default TransactionMessageErrorDetails;
